import { DialogComponent } from '@theme/dialog';

class GeneralQuoteDialog extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    
    const form = this.querySelector('#general-quote-contact-form');
    if (form) {
      form.addEventListener('submit', this.handleFormSubmit.bind(this));
    }

    if (window.location.search.includes('general_quote_posted=true')) {
      this.showSuccessToast();
      const cleanUrl = `${window.location.pathname}${window.location.hash}`;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }

  /**
   * Handles form submission
   * @param {Event} event - The submit event
   */
  handleFormSubmit(event) {
    const form = event.target;
    const formData = new FormData(form);
    const submitButton = form.querySelector('button[type="submit"]');
    const contactBody = form.querySelector('[data-general-contact-body]');

    const company = formData.get('company');
    const project = formData.get('project');
    const highVolume = formData.get('high_volume') === 'yes' ? 'Sí' : 'No';
    
    if (contactBody) {
      contactBody.value = `
Origen: Cotización general desde home
${company ? `Empresa: ${company}\n` : ''}Grandes volúmenes: ${highVolume}

Proyecto:
${project}
      `.trim();
    }

    submitButton.disabled = true;
    submitButton.innerHTML = '<span>Enviando...</span>';
  }

  showSuccessToast() {
    const toast = document.querySelector('[data-quote-success-toast]');

    if (toast) {
      toast.hidden = false;

      setTimeout(() => {
        toast.hidden = true;
      }, 7000);
      return;
    }

    const successMessage = this.querySelector('#form-success-message');
    if (successMessage) {
      this.showDialog();
      successMessage.classList.remove('hidden');
    }
  }
}

if (!customElements.get('general-quote-dialog')) {
  customElements.define('general-quote-dialog', GeneralQuoteDialog);
}

// Function to open the general quote modal from anywhere
export function openGeneralQuoteModal() {
  const dialog = document.getElementById('general-quote-dialog');
  if (dialog && dialog instanceof GeneralQuoteDialog) {
    dialog.showDialog();
  }
}

// Add to window for global access
window.openGeneralQuoteModal = openGeneralQuoteModal;
